module.exports = __webpack_public_path__ + "img/icon01.ac462b3c.png";